import { z } from 'zod';

export const WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_LOW_LABEL_DEFAULT =
  'Low Match';

export const WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_MIXED_THRESHOLD_DEFAULT = 33;
export const WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_MIXED_LABEL_DEFAULT =
  'Mixed Match';

export const WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_STRONG_THRESHOLD_DEFAULT = 66;
export const WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_STRONG_LABEL_DEFAULT =
  'Strong Match';

export const WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_FLAGS_MAX_COUNT_DEFAULT = 2;
export const WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_FLAGS_LABEL_DEFAULT =
  'Flags';

export const WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_FLAGS_EMPTY_LABEL_DEFAULT =
  'No single factor identified as a flag';

export const WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_TOP_QUALITIES_MAX_COUNT_DEFAULT = 2;
export const WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_TOP_QUALITIES_LABEL_DEFAULT =
  'Top Qualities';

export const WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_TOP_QUALITIES_EMPTY_LABEL_DEFAULT =
  'No single factor identified as a top quality';

export const WORKFLOW_SIMPLIFIED_EXPLANATION_CONFIG_DISCLAIMER_LABEL_DEFAULT =
  "* Scored against your company's historical employee success patterns.";

export const WorkflowSimplifiedExplanationConfig = z.object({
  lowLabel: z.string().optional(),
  mixedThreshold: z.number().optional(),
  mixedLabel: z.string().optional(),
  strongThreshold: z.number().optional(),
  strongLabel: z.string().optional(),
  flagsMaxCount: z.number().optional(),
  flagsLabel: z.string().optional(),
  flagsEmptyLabel: z.string().optional(),
  flagsHideQuantities: z.boolean().optional(),
  topQualitiesMaxCount: z.number().optional(),
  topQualitiesLabel: z.string().optional(),
  topQualitiesEmptyLabel: z.string().optional(),
  topQualitiesHideQuantities: z.boolean().optional(),
  disclaimerLabel: z.string().optional(),
});
export type WorkflowSimplifiedExplanationConfig = z.infer<
  typeof WorkflowSimplifiedExplanationConfig
>;

export const WorkflowExplanationFormat = z.enum([
  'long',
  'short',
  'simplified',
]);
export type WorkflowExplanationFormat = z.infer<
  typeof WorkflowExplanationFormat
>;
